module.exports = {
      id: "hamburger-facebook-usage",
      viewBox: "0 0 36 37",
      url: __webpack_public_path__ + "svg-sprite-f2ca7f9d4080f6eed262da64a41d98e9.svg#hamburger-facebook",
      toString: function () {
        return this.url;
      }
    }